import { AVERAGE_UNITS } from 'infrastructure/consts/average-units';
import { useTranslation } from 'react-i18next';
import TrendUpIcon from 'components/atoms/icons/trend-up-icon';
import TrendDownIcon from 'components/atoms/icons/trend-down-icon';

import s from './styles.module.scss';

import type { ThresholdType } from 'infrastructure/enums';
import type {
  IPatientSnapshotPercentage,
  TTrend,
} from 'infrastructure/interfaces';
import type { FC } from 'react';

interface ReadingCardProps {
  type: ThresholdType;
  values: {
    total: number;
    highest: number;
    lowest: number;
    average: number;
  };
  trend: TTrend;
  statusPercentages: IPatientSnapshotPercentage;
}

const ReadingCard: FC<ReadingCardProps> = ({
  type,
  values: { total, highest, lowest, average },
  statusPercentages: { critical, risk, normal },
  trend,
}) => {
  const { t } = useTranslation();

  return (
    <div className={s['reading-item-wrapper']}>
      <div className={s.header}>
        <p className={s.type}>
          {trend === 'up' && <TrendUpIcon className={s.arrow} />}
          {trend === 'down' && <TrendDownIcon className={s.arrow} />}
          {type} <span>{AVERAGE_UNITS[type]}</span>
        </p>
        <div className={s.total}>
          <p>{t('labels.total')}:</p>
          <span>{total}</span>
        </div>
      </div>
      <div className={s.body}>
        <div className={s.counts}>
          <p className={s.count}>
            {t('patientSnapshot.lowest')}:<span>{lowest}</span>
          </p>
          <p className={s.count}>
            {t('patientSnapshot.highest')}:<span>{highest}</span>
          </p>
          <p className={s.count}>
            {t('patientSnapshot.average')}:<span>{average}</span>
          </p>
        </div>
        <div className={s['percentage-line']}>
          <div className={s['red-line']} style={{ maxWidth: `${critical}%` }} />
          <div className={s['yellow-line']} style={{ maxWidth: `${risk}%` }} />
          <div className={s['green-line']} style={{ maxWidth: `${normal}%` }} />
        </div>
      </div>
      <div className={s.percentage}>
        <p>
          <span className={s['red-line']} />
          {t('labels.critical')}: {critical}%
        </p>
        <p>
          <span className={s['yellow-line']} />
          {t('labels.at-risk')}: {risk}%
        </p>
        <p>
          <span className={s['green-line']} />
          {t('labels.normal')}: {normal}%
        </p>
      </div>
    </div>
  );
};
export default ReadingCard;
